<template>
  <div class="export-button-container">
    <v-menu
      absolute
      offset-y
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-tooltip="tooltip"
          x-small
          text
          class="px-0 py-3"
          v-bind="attrs"
          v-on="on"
        >
          <StIcon
            icon-name="dots-vertical"
            size="22"
          />
        </v-btn>
      </template>

      <slot />
    </v-menu>
  </div>
</template>

<script>
import StIcon from '@stilingue/st-icon';

export default {
  name: 'ExportBtn',
  components: {
    StIcon,
  },
  props: {
    tooltip: {
      type: String,
      default: '',
    },
  },
};
</script>
